import appStyles from "./appStyles";
import constants from "./constants";
import strings from "./strings";
import images from "./images";
import config from "../Config/Config";
import list from "./countryCodeList";
import utilFunctions from "./utilFunctions";
import AppointmentCalendar from "../Widgets/AppointmentCalender";

const apiName = {
  hospitalLogin: "api/v1/hospital/auth/sign_in",
  verifyHospitalLogin: "api/v1/hospital/auth/sign_up_precheck",
  getDoctorSpecialtyDepart: "api/v1/hospital/manage/department",
  getLanguages: "api/v1/hospital/manage/languages",
  addDoctor: "api/v1/hospital/manage/doctor",
  azurePrecheck:"api/v1/hospital/provider_check",
  hospitalFcmToken:"api/v1/hospital/fcm_registration",
  doctorFcmToken:"api/v1/doctor/fcm_registration",
  hospitalDelFcmToken:"api/v1/hospital/fcm_deregister",
  doctorDelFcmToken:"api/v1/doctor/fcm_deregister",
  doctorProfile:"api/v1/doctor/profile",
  docGetClinicProfile:"api/v1/doctor/profile/hospital",
  getDashboardAppointments:"api/v1/hospital/appointments",
  docGetAppointmentCalender:"api/v1/doctor/appointments/calendar",
  getDoctorLeaveList:"api/v1/hospital/manage/doctor/availability",
  docCreateDocLeave:"api/v1/doctor/profile/leave",
  docGetLeaveList:"api/v1/doctor/profile/leave",
  uploadDoctorMedia:"api/v1/media/doctor/upload",
  docEditDoctor:"api/v1/doctor/profile",
  docGetAllAppointment:"api/v1/doctor/appointments",
  docGetLanguages:"api/v1/doctor/profile/languages",
  docUploadInvoices:"api/v1/doctor/appointments/medical_files/",
  docLogHolidayList:"api/v1/doctor/profile/leave",
  getDoctorList: "api/v1/hospital/manage/doctor",
  doctorLogin: "api/v1/doctor/auth/sign_in",
  hospitalProfile: "api/v1/hospital/profile",
  updateHospitalProfile: "api/v1/hospital/profile",
  uploadHospitalMedia: "api/v1/media/hospital/upload",
  hospitalAppointment: "api/v1/hospital/appointments",
  getAppointmentCalendar: "api/v1/hospital/appointments/calendar",
  getZoomToken:"/api/v1/hospital/appointments/get_zoom_session/",
  docGetZoomToken:"/api/v1/doctor/appointments/get_zoom_session/",
  createDoctorLeave:"api/v1/hospital/manage/doctor/leave",
  deleteDoctorLeave:"api/v1/hospital/manage/doctor/leave/",
  getDoctorLeave:"/api/v1/hospital/manage/doctor/leave",
  acceptAppointment:"/api/v1/hospital/appointments/update_status",
  docAcceptAppointment:"/api/v1/doctor/appointments/update_status",
  createHospitalLeave: "api/v1/hospital/profile/leave",
  getAllLeaves:"api/v1/hospital/profile/leave",
  deleteHospitalLeave:"api/v1/hospital/profile/leave",
  medicalFiles:"/api/v1/hospital/appointments/medical_files/",
  getAllLeaves: "api/v1/hospital/profile/leave",
  clinicReport:"/api/v1/hospital/appointments/report",
   getCompletedAppointments:"/api/v1/hospital/appointments/report/completed_appointments",
   getDoctorRevenue:"/api/v1/hospital/appointments/report/doctors_revenue",
   doctorReport:"/api/v1/doctor/appointments/report",
   completedAppointmentDoctors:"/api/v1/doctor/appointments/report/completed_appointments"
};

const utils = {
  appStyles,
  constants,
  strings,
  images,
  config,
  list,
  apiName,
  utilFunctions
};

export default utils;
